module.exports = __webpack_public_path__ + "static/rice-blinking-eyes-824b6f5732c9513fc743b9b745de2bf8.gif";